export default __webpack_public_path__ + "ec75df91a72de4f1e972cd71ac153e7c.png";